<template>
  <div>

    <div v-if="isMobile" class="d-flex align-items-center px-3 py-2 bg-light shadow-sm sticky-top">
      <b-button variant="link" class="p-0 mr-2" @click="drawerOpen = true">
        <b-icon-list></b-icon-list>
      </b-button>
      <span class="font-weight-bold">{{ activeTabTitle }}</span>
    </div>

    <b-sidebar
      id="shipping-drawer"
      title="Shipping Menu"
      bg-variant="light"
      text-variant="dark"
      shadow
      backdrop
      placement="left"
      :visible="drawerOpen"
      @hidden="drawerOpen = false"
    >
      <hr/>
      <ul class="list-unstyled m-0">
        <li v-for="(tab, index) in filteredTabs" :key="index" class="mb-2">
          <b-button
            block
            squared
            :variant="activeTabIndex === index ? null : 'link'"
            class="text-left"
            @click="selectTab(index)"
          >
            <b-icon :icon="tab.icon" class="mr-2"></b-icon>
            {{ tab.title }}
          </b-button>
        </li>
      </ul>
    </b-sidebar>

    <div v-if="!isMobile">
      <b-tabs card lazy v-model="activeTabIndex">
        <b-tab
          v-for="(tab, index) in filteredTabs"
          :key="index"
          :title="tab.title"
        >
          <keep-alive>
            <component :is="tab.component"></component>
          </keep-alive>
        </b-tab>
      </b-tabs>
    </div>

    <div v-if="isMobile" class="mt-2">
      <keep-alive>
        <component v-if="activeTabComponent" :is="activeTabComponent"></component>
      </keep-alive>
    </div>

  </div>
</template>

<script>
import {
  BIconList,
  BIconTruck,
  BIconClipboardCheck,
  BIconMap,
  BIconClock,
  BIconCheckCircle
} from "bootstrap-vue";

import ShippingOrders from "@/components/Shipping/ShippingOrders";
import StoreReadyToShip from "../IncomingOutGoing/StoreReadyToShip.vue";
// Import other shipping components as you create them
// import ShippingTracking from "@/components/Shipping/ShippingTracking";
// import ShippingLabels from "@/components/Shipping/ShippingLabels";
// import ShippingSchedule from "@/components/Shipping/ShippingSchedule";
// import ShippingCompleted from "@/components/Shipping/ShippingCompleted";

export default {
  name: "ShippingMain",

  components: {
    ShippingOrders,
    StoreReadyToShip,
    // Add other components here as you create them
    
    BIconList,
    BIconTruck,
    BIconClipboardCheck,
    BIconMap,
    BIconClock,
    BIconCheckCircle
  },

  data() {
    return {
      drawerOpen: false,
      activeTabIndex: 0,
      isMobile: false,

      packet: { userDetails: {} },

      tabs: [
        {
          title: "SHIPPING ORDERS",
          icon: "truck",
          roles: ["admin", "locationadmin", "warehousemanager", "warehouseuser", "deliverytruck"],
          component: "ShippingOrders"
        },
         {
          title: "READY TO SHIP ORDERS",
          icon: "truck",
          roles: ["admin", "locationadmin", "warehousemanager", "warehouseuser", "deliverytruck"],
          component: "StoreReadyToShip"
        },
        // {
        //   title: "TRACKING",
        //   icon: "map",
        //   roles: ["admin", "locationadmin", "warehousemanager", "warehouseuser", "deliverytruck", "accountuser"],
        //   component: "ShippingTracking"
        // },
        // {
        //   title: "SHIPPING LABELS",
        //   icon: "clipboard-check",
        //   roles: ["admin", "locationadmin", "warehousemanager", "warehouseuser"],
        //   component: "ShippingLabels"
        // },
        // {
        //   title: "SCHEDULE",
        //   icon: "clock",
        //   roles: ["admin", "locationadmin", "warehousemanager", "deliverytruck"],
        //   component: "ShippingSchedule"
        // },
        // {
        //   title: "COMPLETED SHIPMENTS",
        //   icon: "check-circle",
        //   roles: ["admin", "locationadmin", "warehousemanager", "accountuser"],
        //   component: "ShippingCompleted"
        // }
      ]
    };
  },

  computed: {
    filteredTabs() {
      const role = this.packet.userDetails.userrole || "";
      return this.tabs.filter(tab => tab.roles.includes(role));
    },
    activeTabTitle() {
      const tab = this.filteredTabs[this.activeTabIndex];
      return tab ? tab.title : "Shipping Menu";
    },
    activeTabComponent() {
      const tab = this.filteredTabs[this.activeTabIndex];
      return tab ? tab.component : null;
    }
  },

  methods: {
    selectTab(index) {
      this.activeTabIndex = index;
      this.drawerOpen = false;
    },
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
    initializeUser() {
      try {
        this.packet = JSON.parse(localStorage.packet || "{}");
        this.packet.userDetails = JSON.parse(localStorage.userDetails || "{}");
      } catch (err) {
        console.error("User data parsing failed:", err);
      }
    }
  },

  created() {
    this.initializeUser();
  },

  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style scoped>
@media (max-width: 767px) {
  .b-tabs {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Shipping/ShippingMain.vue